import { useMemo, useState } from "react";

import InputField from "../../../../conponents/InputField/InputField";
import SelectField from "../../../../conponents/selectField/SelectField";
import PersianDateField from "../../../../conponents/PersianDateField/PersianDateField";

import {

    FaCar,

    FaChevronDown,

    FaChevronUp,

    FaFilter,

} from "react-icons/fa";

import { MdCategory } from "react-icons/md";
import { FaRegStickyNote } from "react-icons/fa";
import { MdRestartAlt } from "react-icons/md";

import styles from "./ExpenseFilterBar.module.css";

const ExpenseFilterBar = ({

    cars = [],

    categories = [],

    filters,

    search,

    setSearch,

    onChange,

    activeFilterCount = 0,

}) => {

    const [

        expanded,

        setExpanded,

    ] = useState(false);

    //------------------------------------------------------

    const carOptions = useMemo(

        () =>

            cars.map(car => ({

                value: car.id,

                label: car.title,
                // label: car.car_title,
                // label: car.carTitle,

            })),

        [cars]

    );

    //------------------------------------------------------

    const categoryOptions = useMemo(

        () =>

            categories.map(category => ({

                value: category.id,

                label: category.typeTitle,

            })),

        [categories]

    );

    //------------------------------------------------------

    // const activeFilterCount = useMemo(() => {

    //     return [

    //         filters.carId,

    //         filters.categoryId,

    //         filters.fromDate,

    //         filters.toDate,

    //         search,

    //     ].filter(

    //         value =>

    //             value !== "" &&

    //             value !== null &&

    //             value !== undefined

    //     ).length;

    // }, [

    //     filters,

    //     search,

    // ]);

    //------------------------------------------------------

    const update = (

        field,

        value

    ) => {

        onChange({

            [field]: value,

        });

    };

    //------------------------------------------------------

    const clearFilters = () => {

        setSearch("");

        onChange({

            carId: "",

            categoryId: "",

            fromDate: "",

            toDate: "",

        });

    };

    //------------------------------------------------------

    return (

        <div className={styles.container}>

            <button

                type="button"

                className={styles.filterButton}

                onClick={() =>

                    setExpanded(

                        previous => !previous

                    )

                }

            >

                <div className={styles.filterTitle}>

                    <FaFilter />

                    <span>

                        فیلترها

                    </span>

                    {

                        activeFilterCount > 0 && (

                            <span

                                className={styles.badge}

                            >

                                {activeFilterCount}

                            </span>

                        )

                    }

                </div>

                {

                    expanded

                        ?

                        <FaChevronUp />

                        :

                        <FaChevronDown />

                }

            </button>

            {

                expanded && (

                    <div className={styles.filters}>

<SelectField

id="carFilter"

name="carFilter"

label="خودرو"

icon={<FaCar />}

value={filters.carId}

options={carOptions}

placeholder="همه خودروها"

onChange={(value) =>

    update(

        "carId",

        value

    )

}

/>

<SelectField

id="categoryFilter"

name="categoryFilter"

label="بابت"

icon={<MdCategory />}

value={filters.categoryId}

options={categoryOptions}

placeholder="همه دسته‌بندی‌ها"

onChange={(value) =>

    update(

        "categoryId",

        value

    )

}

/>

<InputField

id="search"

name="search"

label="توضیحات"

icon={<FaRegStickyNote />}

value={search}

placeholder="جستجو در توضیحات..."

onChange={(event) =>

    setSearch(

        event.target.value

    )

}

/>

<PersianDateField

id="fromDate"

name="fromDate"

label="از تاریخ"

value={filters.fromDate}

onChange={(value) =>

    update(

        "fromDate",

        value

    )

}

/>

<PersianDateField

id="toDate"

name="toDate"

label="تا تاریخ"

value={filters.toDate}

onChange={(value) =>

    update(

        "toDate",

        value

    )

}

/>

<button

type="button"

className={styles.clearButton}

onClick={clearFilters}

>

<MdRestartAlt />

<span>

    پاک کردن فیلترها

</span>

</button>

</div>

)

}

</div>

);

};

export default ExpenseFilterBar;